import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-measure-content" }
const _hoisted_2 = { class: "measure-name" }

import { ref, computed } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { t } from '@/plugins/i18n'
import { ElMessageBox, ElMessage } from 'element-plus'
import { editSizeApi, abnormalEditSizeApi } from '@/apis/goods'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit: emits }) {

const store = useStore()
const visible = ref(false)

const noRuleSizeList = computed(() => {
  console.log(store.getters.shopInfo)
  const isHz = store.getters.shopInfo?.wareName === '杭州仓'
  return isHz ? ['腰围', '臀围'] : []
})
const cancel = () => {
  visible.value = false
}
const measureList: any = ref([])
const ok = () => {
  let isWarning = false
  measureList.value.forEach((item: any) => {
    if (!item.value && !isWarning) {
      isWarning = true
      ElMessage.warning(`【${t(item.name)}】${t('请填写')}`)
    }
  })
  if (isWarning) return
  if (comType.value === 2) {
    abnormalEditSizeApi({
      productSku: id.value,
      productMeasureDtoList: measureList.value,
      customerId: store.getters.user?.customerId
    }).then((res) => {
      if (res.success) {
        ElMessage.success(t('保存成功'))
        visible.value = false
        emits('success')
      }
    })
    return
  }
  ElMessageBox.confirm(t('最新的入库要求会更新为已编辑数据的，请知悉'), t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning'
  })
    .then(() => {
      editSizeApi({
        id: id.value,
        productMeasureDtoList: measureList.value
      }).then((res) => {
        if (res.success) {
          ElMessage.success(t('保存成功'))
          visible.value = false
          emits('success')
        }
      })
    })
}
const changeInput = (e, item: any) => {
  if (noRuleSizeList.value.includes(item.name)) {
    item.value = e.replace(/[^0-9./]/g, '')
    return
  }
  item.value = e.replace(/^(\d*\.?\d*).*/, '$1')
}
const id = ref('')
const comType = ref(1) // 1 尺寸测量页面编辑 2 异常单编辑尺寸
expose({
  open: (record: any) => {
    visible.value = true
    id.value = record.id
    comType.value = record.comType
    measureList.value = JSON.parse(JSON.stringify(record.productMeasureDtoList ?? []))
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(CommonDialog, {
    onCancel: cancel,
    className: "edit-measure-modal",
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    width: 800,
    "append-to-body": "",
    "modal-class": "edit-measure-modal",
    title: _unref(t)('编辑商品情报'),
    footer: true,
    onOk: ok
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measureList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-measure-item",
            key: item.code
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(item.name)) + "(CM):", 1),
            _createVNode(_component_el_input, {
              style: {"width":"180px"},
              modelValue: item.value,
              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
              onInput: e => changeInput(e, item)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})